import React, { useState } from 'react';
import classNames from 'classnames';
import Button from './Button';
import PopOver from './deprecated/PopOver';
import * as styles from './UnsplashColorPicker.module.scss';
import PopOverContainer from './deprecated/PopOverContainer';
import Caret from './Caret';
import type { SupportedColorId } from './UnsplashColors';
import UnsplashColors, { UnsplashColor } from './UnsplashColors';

interface UnsplashColorPickerProps {
  value: SupportedColorId | null;
  onChange: (value: SupportedColorId | null) => void;
}

const UnsplashColorPicker = ({ value, onChange }: UnsplashColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PopOver
      open={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-start"
      popOver={
        <PopOverContainer width="auto">
          <div className={styles.label}>Filter by color</div>
          <UnsplashColors onSelect={onChange} value={value} />
        </PopOverContainer>
      }
      popOverPortal={document.body}
      trigger="click"
    >
      <Button
        className={classNames(styles.picker, { [styles.isOpen]: isOpen })}
      >
        <UnsplashColor color={value} />
        <Caret direction={isOpen ? 'up' : 'down'} size={12} />
      </Button>
    </PopOver>
  );
};

export default UnsplashColorPicker;
